import { useEffect, useState } from 'react';
import { LuDownload } from 'react-icons/lu';

import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { downloadFile } from 'utils/file-download';

type InvoicePreviewDialogProps = {
    blob: Blob | null;
    fileName: string;
    open: boolean;
    onOpenChange: (open: boolean) => void;
};

export const InvoicePreviewDialog = ({ blob, fileName, open, onOpenChange }: InvoicePreviewDialogProps) => {
    const [objectUrl, setObjectUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!blob) {
            setObjectUrl(null);
            return;
        }
        const url = URL.createObjectURL(blob);
        setObjectUrl(url);
        return () => URL.revokeObjectURL(url);
    }, [blob]);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="flex h-[90vh] max-w-4xl flex-col bg-white">
                <DialogHeader>
                    <DialogTitle>Invoice preview</DialogTitle>
                </DialogHeader>
                {objectUrl && (
                    // `navpanes=0` suppresses the browser PDF viewer's thumbnail/outline sidebar.
                    <iframe
                        src={`${objectUrl}#navpanes=0`}
                        title="Invoice preview"
                        className="w-full flex-1 border-0"
                    />
                )}
                <DialogFooter>
                    <Button disabled={!objectUrl} onClick={() => objectUrl && downloadFile(fileName, objectUrl)}>
                        <LuDownload className="h-4 w-4" />
                        Download invoice
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
